var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalNoticeContainer',[_c('div',{staticClass:"home-wrapper"},[_c('h2',{staticClass:"header"},[_vm._v("pulseData Application Suite")]),_vm._v(" "),_vm._l((_vm.apps),function(app){return _c('AppCard',{key:app.id,attrs:{"link":app.url,"name":app.title,"details":app.description}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cd49242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/Home.vue
// module id = null
// module chunks = 